import { render, staticRenderFns } from "./MenuEditAcademy.vue?vue&type=template&id=daf9036c&scoped=true&lang=pug&"
import script from "./MenuEditAcademy.vue?vue&type=script&lang=ts&"
export * from "./MenuEditAcademy.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEditAcademy.vue?vue&type=style&index=0&id=daf9036c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf9036c",
  null
  
)

export default component.exports